export const PRODUCTS_PER_PAGE = 28;
